import { render, staticRenderFns } from "./buyed.vue?vue&type=template&id=2ec40b3e&scoped=true"
import script from "./buyed.vue?vue&type=script&lang=js"
export * from "./buyed.vue?vue&type=script&lang=js"
import style0 from "./buyed.vue?vue&type=style&index=0&id=2ec40b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec40b3e",
  null
  
)

export default component.exports